module.exports = __webpack_public_path__ + "media/audio2.58993b5f.wav";